import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=3cee8245&scoped=true&"
import script from "./ShopItem.vue?vue&type=script&lang=js&"
export * from "./ShopItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShopItem.vue?vue&type=style&index=1&id=3cee8245&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cee8245",
  null
  
)

export default component.exports